import Areas from "./Areas";
import Confirm from "./Confirm";
import Document from "./Document";

// Map of chapterdef KEY: Component
export default {
  FAULTS: Areas,
  DOCUMENT: Document,
  CONFIRM: Confirm,
};
